import { Component, Input } from '@angular/core';

@Component({
    selector: 'xm-loader-overlay',
    styleUrls: ['./loader-overlay.scss'],
    templateUrl: './loader-overlay.html',
    standalone: false
})
export class LoaderOverlayComponent {
    @Input() public type: string;
    @Input() public page: string;
    @Input() public avatar: boolean = false;
    @Input() public isAddonsCards: boolean = false;
    @Input() public lineBanner: boolean = false;
}
